import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { CreatePathAPI, EditPathAPI } from "../../../API/PathAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { PathModel } from "../../../Models/PathModel";

interface IEditPathComponentProps {
    show: boolean,
    handleClose: () => void,
    toggleLoading: (data: boolean) => void,
    path: PathModel,
    userEmail: string,
    setPathsHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    pathMain: string
}

const EditPathComponent = (props: IEditPathComponentProps) => {
    const [pathName, setPathName] = useState<string>(props.path.pathName);

    const editPath = async () => {
        try {
            props.toggleLoading(true);

            await EditPathAPI(pathName, props.path.id, props.userEmail, props.pathMain, props.path.parentFolderId, props.path.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    toast.success(`pasta editada com sucesso!`);
                    props.setPathsHasChanged(true);
                    props.handleClose();
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    useEffect(() => {
        if (props.path) {
            setPathName(props.path.pathName);
        }
    }, [props.path]);

    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Subpasta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label className="required">Nome da pasta:</label>
                <input required value={pathName} onChange={(e) => setPathName(e.target.value)} className="w-100 form-control mt-1" />
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={pathName == "" || pathName == props.path.pathName} className='btn btn-primary w-100' onClick={editPath}>
                    Editar Pasta
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default EditPathComponent;